import { createTheme } from "@mui/material/styles";

declare module "@mui/material/styles" {
  interface Palette {
    custom: {
      brandGold: string;
      brandBrown: string;
      brandTeal: string;
      brandPrimary: string;
      lightBlue: string;
      darkBlue: string;
      mapWhite: string;
      grey: string;
      hellbraun1: string;
      hellbraun2: string;
      hellbraun3: string;
      dunkelbraun: string;
      dunkelblau: string;
      darkgrey: string;
    };
  }
  interface PaletteOptions {
    custom?: {
      brandGold?: string;
      brandBrown?: string;
      brandTeal?: string;
      brandPrimary?: string;
      lightBlue?: string;
      darkBlue?: string;
      mapWhite?: string;
      grey?: string;
      darkGreen?: string;
      darkGreen2?: string;
      hellbraun1?: string;
      hellbraun2?: string;
      hellbraun3?: string;
      dunkelbraun?: string;
      dunkelblau?: string;
      darkgrey?: string;
    };
  }
}

const theme = createTheme({
  typography: {
    fontFamily: `"Montserrat", sans-serif`,
  },
  breakpoints: {
    values: {
      xl: 1920,
      lg: 1280,
      md: 960,
      sm: 600,
      xs: 0,
    },
  },
  palette: {
    primary: {
      main: "#1D2F41", // Brand Primary Dark Blue
    },
    secondary: {
      main: "#2B6161", // Brand Teal
    },
    custom: {
      brandGold: "#D1BE92",
      brandBrown: "#474131",
      brandTeal: "#2B6161",
      brandPrimary: "#1D2F41",
      lightBlue: "#78c4f0",
      darkBlue: "#0658d7",
      mapWhite: "#e4e4e4",
      grey: "#5f6a6f",
      hellbraun1: "#d1be92",
      hellbraun2: "#ddd1b4",
      hellbraun3: "#ede7d8",
      dunkelbraun: "#474131",
      dunkelblau: " #1d2f41",
      darkgrey: "#54555d",
    },
  },
  shape: {
    borderRadius: 8,
  },
  spacing: 8,
});

export default theme;
